import React from 'react';
import cn from 'classnames';
import first from 'lodash/first';
import { TooltipConstants } from '@Components/Tooltip';
import PropTypes from 'prop-types';
import {
  routeLayoutGetMaxDepth,
  routeLayoutNest,
  routeLayoutPerformRouteName,
} from '@Pages/RetroSynthesis/ProjectRoutes/components/RsProjectRouteHelper';
import RouteThumbnailsTree from '@Pages/RetroSynthesis/RouteTree/components/RouteThumbnailsTree';
import { RouteType } from '@Pages/RetroSynthesis/constants';
// eslint-disable-next-line import/no-named-as-default
import RsSlidablePaginated from '@Pages/RetroSynthesis/components/RsSlidablePaginated/RsSlidablePaginated';
import { fetchProjectRoutesLightweightAction } from '@Pages/RetroSynthesis/ProjectRoutes/actions';
import HoverTooltip from '@Components/HoverTooltip';

import './RsRoutesSelectionBar.scss';

function RsRoutesSelectionBar({ activeRoute, setActiveRoute, projectId }) {
  const renderRoute = (route) => {
    const routeName = routeLayoutPerformRouteName(route.routeType, route.id);
    const routeTree = first(routeLayoutNest(route.routeLayout));
    const keyHandler = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        setActiveRoute(route);
      }
    };
    return (
      <HoverTooltip
        id={TooltipConstants.ids.GlobalHover}
        className="routes-selection-list__flyout"
        tooltip={routeName}
        theme="simple"
        style={{ width: `${routeLayoutGetMaxDepth(routeTree, 1) * 0.625 + 3}rem` }}>
        <div
          className={cn(
            'routes-selection-list__step-wrapper',
            { predicted: route.routeType === RouteType.PREDICTED },
            { published: route.routeType === RouteType.PUBLISHED },
            { customized: route.routeType === RouteType.CUSTOMIZED }
          )}
          onClick={() => setActiveRoute(route)}
          onKeyPress={keyHandler}
          tabIndex={0}
          role="link"
          style={{ width: `${routeLayoutGetMaxDepth(routeTree, 1) * 0.625 + 3}rem` }}>
          <RouteThumbnailsTree
            tree={routeTree}
            routeName={routeName}
            routeId={route.id}
            allowTruncation={false}
            nodeWidth={5}
            nodeHeight={3}
            depthFactor={10}
            rectSize={5}
            circleSize={2}
            focusableNodes={false}
          />
        </div>
      </HoverTooltip>
    );
  };

  const getActiveRouteIndex = (items, item) => items.findIndex((route) => route.id.toString() === item);
  const loadRoutesAsyncAction = async (params) => fetchProjectRoutesLightweightAction(projectId, params);

  return (
    <RsSlidablePaginated
      className="routes-selection-list rx-flex-1 w0"
      containerClassName="routes-selection-list__cont"
      contentClassName="routes-selection-list__list"
      itemClassName={(route) => cn('routes-selection-list__step', { current: route && route.id.toString() === activeRoute })}
      renderItem={renderRoute}
      loadItemsAsync={loadRoutesAsyncAction}
      centerItemsIfNavigationControlsNotVisible
      selectedItem={activeRoute}
      getSelectedItemIndex={getActiveRouteIndex}
      minimumItemWidth={70}
      defaultPageSize={40}
    />
  );
}

RsRoutesSelectionBar.propTypes = {
  setActiveRoute: PropTypes.func,
  activeRoute: PropTypes.string,
  projectId: PropTypes.string,
};

export default RsRoutesSelectionBar;
